import { OAuthAuthenticationService } from '@ipc/ipc-core';

export const ROLE_OPERATOR = 'ROLE_POSTAL_OPERATOR';
export const ROLE_CARRIER = 'ROLE_CARRIER';
export const ROLE_ADMIN = 'ROLE_IPC_ADMIN';

export const hasAccess = rolesToCheck => rolesToCheck.some(role => OAuthAuthenticationService.roles().includes(role));
